import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DrawingMapToolComponent } from './components/drawing-map-tool/drawing-map-tool.component';
import { EauComponent } from './components/eau/eau.component';
import { InterventionListComponent } from './components/intervention-list/intervention-list.component';
import { InterventionComponent } from './components/intervention/intervention.component';
import { LingetteComponent } from './components/lingette/lingette.component';
import { MassifComponent } from './components/massif/massif.component';
import { AppareilMesureComponent } from './components/metrologie/appareil-mesure.component';
import { PointageComponent } from './components/pointage/pointage.component';
import { ProcessComponent } from './components/process/process.component';
import { RedirectComponent } from './components/redirect/redirect.component';
import { ScanComponent } from './components/scan/scan.component';
import { WeeklyListComponent } from './components/weekly-list/weekly-list.component';
import { ZoneComponent } from './components/zone/zone.component';
import { ErrorComponent } from './error.component';
import { ENavigationRoute } from './model/enum/navigation-route';
import { LoginGuard } from './tools/login-guard';
import { AdductionComponent } from './components/adduction/adduction.component';
import { GenericsComponent } from './components/generics/generics.component';

const routes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: ENavigationRoute.InterventionList },
    { path: ENavigationRoute.WeeklyList, component: WeeklyListComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.InterventionList, component: InterventionListComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.Intervention, component: InterventionComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.ZoneMeasure, component: ZoneComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.ProcessMeasure, component: ProcessComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.MassifMeasure, component: MassifComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.EauMeasure, component: EauComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.LingetteMeasure, component: LingetteComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.DrawingTool, component: DrawingMapToolComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.Pointage, component: PointageComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.Metrologie, component: AppareilMesureComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.Scan, component: ScanComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.Adduction, component: AdductionComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.Generics, component: GenericsComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.Error, component: ErrorComponent },
    { path: 'redirect', component: RedirectComponent },
    { path: '**', component: ErrorComponent }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule { }
